var React = require('react');

function Home (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20 7.007l-7.32-4.52a1.33 1.33 0 00-1.36 0L4 7.007v10.39a.89.89 0 00.89.9h4.33v-8h5.56v8h4.33a.891.891 0 00.89-.9V7.007z","fill":"#001B35"}));
}

Home.defaultProps = {"fill":"none","viewBox":"0 0 24 24"};

module.exports = Home;

Home.default = Home;
